import { render, staticRenderFns } from "./category-rewards.vue?vue&type=template&id=ab0d7542"
import script from "./category-rewards.vue?vue&type=script&lang=js"
export * from "./category-rewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports